<script>
    import {afterUpdate} from 'svelte';
    import Modal from 'svelte-simple-modal';
    import Button from "./components/Button.svelte";
    import {componentName as storeComponentName, form as formStore} from "./stores/store";

    export let componentName;

    export let iblock;
    export let event;
    export let defaultData = [];
    export let captchaSitekey = '';

    export let formTitle;
    export let buttonText;
    export let buttonClass;

    let isReady = false;
    let isInited = false;

    afterUpdate(() => {
        if (!isInited && componentName) {
            isInited = true;
            storeComponentName.set(componentName);
            isReady = true;
            formStore.set({
                buttonText,
                buttonClass,
                defaultData,
                captchaSitekey,
                iblock,
                event,
                success: false
            });
        }
    });
</script>

{#if isReady}
    <Modal>
        <Button {formTitle} {buttonText} {buttonClass}/>
    </Modal>
{/if}
